{{#if isPipelined}}
{{#with sequenceItemHandle}}
virtual function void drop_transaction({{ type }} {{ identifier }});
  {{ ../activeTransactionsVariable.identifier }}.delete({{ identifier }}.id);
  {{ ../numActiveTransactionsVariable.identifier }}--;
endfunction
{{/with}}
{{/if}}
